var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-FlashReport_Icon"},[_c(_vm.comp,{tag:"component",staticClass:"sw-Icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }